import React from "react";
import PropTypes from "prop-types";
import { /*Input, */NumericTextBox } from '@progress/kendo-react-inputs';
import { isEmpty, getMonths/*, queryStringBuilder, convertDatestampToObject, getLocaleDateString*/ } from "../helpers";
//import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from '@progress/kendo-react-buttons';
import "@progress/kendo-theme-material/dist/all.css";
import isPage from "../hoc/isPage";
//import { AppContext } from '../context/AppContext';
import FormSection from '../components/FormSection';
import Toolbar from "../components/Toolbar";
import ToolbarOption from '../components/ToolbarOption';
import Input from '../components/Input'
//import FormItem from '../components/FormItem';
import DropDownContainer from '../components/DropDownContainer';

class EditSeasonPage extends React.Component {
    static propTypes = {
        //seasonID: PropTypes.number,
        orgID: PropTypes.number,
        //seasonName: PropTypes.string,
        //startMonth: PropTypes.number,
        //startDay: PropTypes.number,
        //endMonth: PropTypes.number,
        //endDay: PropTypes.number,
        //inactive: PropTypes.bool,
        season: PropTypes.object,
        handleCloseModal: PropTypes.func
    }

    state = {
        seasonID: null,
        seasonName: '',
        startMonth: null,
        startDay: null,
        endMonth: null,
        endDay: null,
        inactive: false,

        showConfirmationDialog: false
    }

    componentDidMount() {

        const MONTHS = getMonths(this.props.getLanguage());

        //this.props.getData('/api/portal/adjustmentReason/GetList').then((adjustmentReasons) => {
        //    this.setState({
        //        adjustmentReasons: [{ adjustmentReasonID: null, adjustmentReason: "" }].concat(adjustmentReasons.data),
        //    })
        //})
        if (this.props.season) {
            this.setState({
                seasonID: this.props.season.seasonID,
                seasonName: this.props.season.seasonName,
                startMonth: MONTHS.find(m => m.monthID === this.props.season.startMonth),
                startDay: this.props.season.startDay,
                endMonth: MONTHS.find(m => m.monthID === this.props.season.endMonth),
                endDay: this.props.season.endDay,
                inactive: this.props.season.inactive
            });
        }
        else {
            this.setState({
                seasonID: null,
                seasonName: '',
                startMonth: null,
                startDay: null,
                endMonth: null,
                endDay: null,
                inactive: false
            });
        }
    }

    handleCloseConfirmationDialog = (e, props) => {

        this.setState({
            showConfirmationDialog: false
        });
    }

    handleSubmit = (e, skipConfirmation) => {
        // do a post to /api/portal/season/{orgID}

        let apiUrl = `/api/portal/season/${this.props.orgID}`;

        // "set" or "deleted"
        let action = '';

        // validation
        const { seasonID, seasonName, startMonth, startDay, endMonth, endDay, inactive } = this.state;

        let errorMessage = '';
        if (isEmpty(seasonName)) {
            errorMessage = this.props.returnLocalizedString("m0157");
        }
        else if (!(startMonth && startMonth.monthID > 0)) {
            errorMessage = this.props.returnLocalizedString("m0158");
        }
        else if (!(startDay && startDay > 0)) {
            errorMessage = this.props.returnLocalizedString("m0159");
        }
        else if (!(endMonth && endMonth.monthID > 0)) {
            errorMessage = this.props.returnLocalizedString("m0160");
        }
        else if (!(endDay && endDay > 0)) {
            errorMessage = this.props.returnLocalizedString("m0161");
        }

        if (!isEmpty(errorMessage)) {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), errorMessage);
            return;
        }

        if (!skipConfirmation) {
            if (inactive) {
                // bring up the dialog
                this.setState({
                    showConfirmationDialog: true
                });
                return;
            }
        }

        const payload = {
            //orgID: this.props.orgID,
            seasonID: seasonID,
            seasonName: seasonName,
            startMonth: startMonth.monthID,
            startDay: startDay,
            endMonth: endMonth.monthID,
            endDay: endDay,
            inactive: inactive
        };

        action = 'm0138';
        //console.log('submitting this info', JSON.stringify(payload));

        //let hasError = false;
        this.props.postData(apiUrl, payload).then(response => {
            if (payload.seasonID === null) {
                payload.seasonID = response.data;
            }

            this.props.alert("success", this.props.returnLocalizedString("m0036"), this.props.returnLocalizedString("m0162", action));

            //this.props.handleRefreshListing();
            this.props.handleCloseModal(this, payload);

        }).catch(error => {
            //hasError = true;
            //console.log('set/delete exception error: ', error.message)
            this.props.alert("error", this.props.returnLocalizedString("m0163", action), `${error.response.data}`);
        });

        //if (!hasError)
        //    this.props.handleCloseModal(this, payload);
    }

    handleClearData = () => {
        this.setState({
            seasonID: null,
            seasonName: '',
            startMonth: null,
            startDay: null,
            endMonth: null,
            endDay: null,
            inactive: false
        });
    }

    handleChange = (e) => {

        if (["inactive"].includes(e.target.name)) {
            this.setState({
                [e.target.name]: e.target.checked
            });
        }
        else if (["startMonth"].includes(e.target.name)) {
            let startDayMax = 31;
            let { startDay } = this.state;
            if (e.target.value && e.target.value.monthID > 0) {
                startDayMax = this.getMaxDayOfMonth(e.target.value.monthID);
                if (startDay > startDayMax)
                    startDay = startDayMax;
            }

            this.setState({
                [e.target.name]: e.target.value,
                startDay: startDay
            });
        }
        else if (["endMonth"].includes(e.target.name)) {
            let endDayMax = 31;
            let { endDay } = this.state;
            if (e.target.value && e.target.value.monthID > 0) {
                endDayMax = this.getMaxDayOfMonth(e.target.value.monthID);
                if (endDay > endDayMax)
                    endDay = endDayMax;
            }

            this.setState({
                [e.target.name]: e.target.value,
                endDay: endDay
            });
        }
        else {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    getMaxDayOfMonth = (month) => {
        let dayMax = 31;
        switch (month) {
            case 4:
            case 6:
            case 9:
            case 11:
                dayMax = 30;
                break;
            case 2:
                dayMax = 28;
                break;
            //case 1:
            //case 3:
            //case 5:
            //case 7:
            //case 8:
            //case 10:
            //case 12:
            //    dayMax = 31;
            //    break;
            default:
        }
        return dayMax;
    }

    render() {
        let startDayMax = 31;
        const { startMonth, endMonth } = this.state;
        if (startMonth && startMonth.monthID > 0) {
            startDayMax = this.getMaxDayOfMonth(startMonth.monthID);
        }

        let endDayMax = 31;
        if (endMonth && endMonth.monthID > 0) {
            endDayMax = this.getMaxDayOfMonth(endMonth.monthID);
        }

        //let top = window.visualViewport.pageTop + (window.innerHeight - 200) / 2;
        let top = window.pageYOffset + (window.innerHeight - 200) / 2;

        //<TextField name="seasonName" label="Season Name" value={this.state.seasonName} handleChange={this.handleChange} required={true} />

        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0036@ Success! !DEVNOTE! Action status
        //!DBTRANS! @m0095@ Inactive !DEVNOTE! Form field
        //!DBTRANS! @m0154@ Warning !DEVNOTE! Text label
        //!DBTRANS! @m0138@ set !DEVNOTE! Action status reason
        //!DBTRANS! @m0139@ deleted !DEVNOTE! Action status
        //!DBTRANS! @m0156@ Are you sure you want to continue? !DEVNOTE! Option label
        //!DBTRANS! @m0157@ You must set season name. !DEVNOTE! Action status reason
        //!DBTRANS! @m0158@ You must set start month. !DEVNsOTE! Action status reason
        //!DBTRANS! @m0159@ You must set start day. !DEVNOTE! Action status reason
        //!DBTRANS! @m0160@ You must set end month. !DEVNOTE! Action status reason
        //!DBTRANS! @m0161@ You must set end day. !DEVNOTE! Action status reason
        //!DBTRANS! @m0162@ The season was %action%! !DEVNOTE! Action status
        //!DBTRANS! @m0163@ The season could not be %action%. !DEVNOTE! Action status
        //!DBTRANS! @m0164@ Season settings !DEVNOTE! Field name
        //!DBTRANS! @m0165@ Season Name:* !DEVNOTE! Field name
        //!DBTRANS! @m0166@ Start month:* !DEVNOTE! Field name
        //!DBTRANS! @m0167@ Start day:* !DEVNOTE! Field name
        //!DBTRANS! @m0168@ End month:* !DEVNOTE! Field name
        //!DBTRANS! @m0169@ End day:* !DEVNOTE! Field name
        //!DBTRANS! @m0170@ Saving the season %var1% as inactive will remove the season settings for all parts assigned to the season. !DEVNOTE! Setting warning

        return (
            <div className="position-relative">
                <div className="k-window-title k-dialog-title exception-settings">{this.props.returnLocalizedString("m0164")}</div>
                <div className="grid">
                    <div className="grid-row">
                        <div className="grid-col m-col-12 d-col-12">
                            <FormSection>
                                <div>
                                    <span className="k-form-field">
                                        <Input required={true} label={this.props.returnLocalizedString("m0165")} name="seasonName" type="text" onChange={this.handleChange} value={this.state.seasonName} />
                                    </span>
                                </div>
                                <div>
                                    <span className="k-form-field right-margin-20 drop-down-field">
                                        <DropDownContainer
                                            id="startMonth"
                                            value={this.state.startMonth}
                                            required={true}
                                            hasEmptyOption={false}
                                            label={this.props.returnLocalizedString("m0166")}
                                            name="startMonth"
                                            dataType="months"
                                            uiLanguage={this.props.getLanguage()}
                                            handleChange={this.handleChange}
                                        />
                                    </span>
                                    <span className="k-form-field right-field">
                                        <NumericTextBox name="startDay" label={this.props.returnLocalizedString("m0167")} spinners={false} min={1} max={startDayMax} value={this.state.startDay} onChange={this.handleChange} required={true} />
                                    </span>
                                </div>
                                <div>
                                    <span className="k-form-field right-margin-20 drop-down-field">
                                        <DropDownContainer
                                            id="endMonth"
                                            value={this.state.endMonth}
                                            required={true}
                                            hasEmptyOption={false}
                                            label={this.props.returnLocalizedString("m0168")}
                                            name="endMonth"
                                            dataType="months"
                                            uiLanguage={this.props.getLanguage()}
                                            handleChange={this.handleChange}
                                        />
                                    </span>
                                    <span className="k-form-field right-field">
                                        <NumericTextBox name="endDay" label={this.props.returnLocalizedString("m0169")} spinners={false} min={1} max={endDayMax} value={this.state.endDay} onChange={this.handleChange} required={true} />
                                    </span>
                                </div>
                                <div className="boolean" >
                                    <input type="checkbox" id="season-inactive" name="inactive" checked={this.state.inactive} className="k-checkbox" onChange={this.handleChange} />
                                    <label className="k-checkbox-label" htmlFor="season-inactive">{this.props.returnLocalizedString("m0095")}</label>
                                </div>
                                {this.state.showConfirmationDialog && (
                                    <Dialog className="confirmation"
                                        width={500}
                                        style={{ height: 'auto', top: top, margin: '0 auto' }}
                                        closeIcon={false}
                                        title={this.props.returnLocalizedString("m0154")}
                                        onClose={this.handleCloseConfirmationDialog}>

                                        {this.props.returnLocalizedString("m0170")}
                                        <br />
                                        {this.props.returnLocalizedString("m0156")}
                                        <DialogActionsBar>
                                            <Button className="cancel" onClick={(e) => {
                                                this.handleCloseConfirmationDialog();
                                            }}>No</Button>
                                            <Button className="yes" primary={true} onClick={(e) => {
                                                this.handleSubmit(e, true);
                                                this.handleCloseConfirmationDialog();
                                            }}>Yes</Button>
                                        </DialogActionsBar>
                                    </Dialog>)
                                }                            </FormSection>
                            <Toolbar onEditScrtooltip={false} atBottom={true} >
                                <ToolbarOption onEditScrtooltip={false} type="cancel" handleClick={this.props.handleCloseModal} />
                                <ToolbarOption onEditScrtooltip={false} type="save" primary={true} handleClick={this.handleSubmit} />
                            </Toolbar>
                        </div>
                    </div>
                </div>
                <Toolbar forPartException={true} >
                    <ToolbarOption onEditScrtooltip={false} type="clear" handleClick={this.handleClearData} />
                </Toolbar>
            </div>
        )
    }
}
export default isPage(EditSeasonPage);

//const TextField = ({ name, label, value, handleChange, required = false }) => {
//    return (
//        <FormItem>
//            <label htmlFor={name}>{label}:{required ? '*' : ''} </label>
//            <Input placeholder={label} id={name} required={required} value={value} onChange={handleChange} name={name} type="text" />
//        </FormItem>
//    )
//}



// WEBPACK FOOTER //
// ./src/containers/EditSeasonPage.js